exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".columns[data-v-3fb30536]{margin:20px}.button-bar[data-v-3fb30536]{margin-top:20px}.content ul[data-v-3fb30536]{color:#fff}.content ul li strong[data-v-3fb30536]{color:#a3ff00}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3fb30536","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/TrackDetail.vue
// module id = 72
// module chunks = 0